import { useEffect } from 'react';
import { initializeGleap } from '../../utils';

interface UseGleapsIntegrationWithConfigProps {
  enable?: boolean;
  apiKey?: string;
  onError?: (error: any) => void;
}

const useGleapsIntegrationWithConfig = ({
  enable = true,
  onError,
}: UseGleapsIntegrationWithConfigProps = {}) => {
  const apiKey = process.env.REACT_APP_GLEAP_API_KEY;

  useEffect(() => {
    if (!enable) return;

    try {
      if (apiKey) {
        initializeGleap(apiKey);
      }
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.error('Error initializing Gleap:', error);
      }
      onError?.(error);
    }
  }, [enable, apiKey, onError]);

  return null;
};

export default useGleapsIntegrationWithConfig;
